const DoubleChevronIcon = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 24.009 24.009"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="currentColor">
      <path d="m20.074 10.32c-.288 0-.578-.095-.819-.291l-7.25-5.896-7.25 5.896c-.558.453-1.375.369-1.829-.188-.453-.557-.369-1.376.188-1.829l8.071-6.563c.478-.388 1.162-.389 1.641 0l8.07 6.562c.557.453.642 1.272.188 1.829-.257.316-.632.479-1.01.479z" />
      <path d="m3.936 13.689c.288 0 .578.095.819.291l7.25 5.896 7.25-5.896c.558-.453 1.375-.369 1.829.188.453.557.369 1.376-.188 1.829l-8.07 6.562c-.478.388-1.162.389-1.641 0l-8.071-6.561c-.557-.453-.642-1.272-.188-1.829.257-.316.632-.479 1.01-.479z" />
    </g>
  </svg>
)

export default DoubleChevronIcon